<template>
  <div class="vt-wrapper">
    <div class="vt-header" v-if="showHeader">
      <div class="vt-th" v-for="col in columns" :key="col">{{ col }}</div>
      <div class="vt-th vt-op" v-if="showOperation">操作</div>
    </div>
    <div class="vt-body" ref="scrollEl" @scroll="onScroll">
      <div :style="spacerStyleTop"></div>
      <div class="vt-row" v-for="(row, i) in visibleRows" :key="row.__vt_id">
        <div class="vt-td" v-for="col in columns" :key="col">
          <input class="vt-input" :value="row[col]" @input="e=>onCellInput(row.__source_index, col, e.target.value)" />
        </div>
        <div class="vt-td vt-op" v-if="showOperation">
          <button class="vt-btn" @click="$emit('remove-row', row.__source_index)">删</button>
        </div>
      </div>
      <div :style="spacerStyleBottom"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VirtualTable',
  props: {
    rows: { type: Array, required: true },
    columns: { type: Array, required: true },
    rowHeight: { type: Number, default: 36 },
    keeps: { type: Number, default: 40 },
    buffer: { type: Number, default: 10 },
    height: { type: Number, default: 480 },
    showHeader: { type: Boolean, default: true },
    showOperation: { type: Boolean, default: true }
  },
  data() {
    return {
      start: 0,
      scrollTop: 0
    }
  },
  computed: {
    total() { return this.rows.length },
    end() { return Math.min(this.start + this.keeps, this.total) },
    visibleRows() {
      const slice = this.rows.slice(this.start, this.end).map((r, idx) => ({
        ...r,
        __vt_id: r.__vt_id || (r.__vt_id = 'r'+(this.start+idx)),
        __source_index: this.start + idx
      }))
      return slice
    },
    spacerStyleTop() {
      return { height: this.start * this.rowHeight + 'px' }
    },
    spacerStyleBottom() {
      const remain = (this.total - this.end) * this.rowHeight
      return { height: remain + 'px' }
    }
  },
  methods: {
    onScroll() {
      const el = this.$refs.scrollEl
      this.scrollTop = el.scrollTop
      const firstIndex = Math.floor(this.scrollTop / this.rowHeight) - this.buffer
      const newStart = Math.max(0, firstIndex)
      if (newStart !== this.start) this.start = newStart
    },
    onCellInput(rowIndex, col, val) {
      this.$emit('cell-change', { rowIndex, field: col, value: val })
    }
  }
}
</script>

<style scoped>
.vt-wrapper { border:1px solid #ebeef5; font-size:12px; background:#fff; }
.vt-header { display:flex; background:#f5f7fa; border-bottom:1px solid #ebeef5; position:sticky; top:0; z-index:2; }
.vt-th { flex:1 0 0; padding:6px 8px; font-weight:600; border-right:1px solid #ebeef5; }
.vt-th:last-child, .vt-td:last-child { border-right:none; }
.vt-body { overflow:auto; height:480px; position:relative; font-size:12px; }
.vt-row { display:flex; border-bottom:1px solid #f0f0f0; min-height:36px; box-sizing:border-box; }
.vt-td { flex:1 0 0; padding:4px 6px; display:flex; align-items:center; border-right:1px solid #f5f5f5; }
.vt-input { width:100%; border:1px solid #dcdfe6; height:24px; font-size:12px; padding:0 4px; box-sizing:border-box; border-radius:2px; }
.vt-input:focus { outline:none; border-color:#409EFF; }
.vt-op { width:60px; flex:0 0 60px; text-align:center; }
.vt-btn { cursor:pointer; background:#f56c6c; border:none; color:#fff; padding:4px 6px; border-radius:3px; font-size:12px; }
.vt-btn:hover { opacity:.85; }
</style>